import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import playerImg from '@assets/images/placeholder/playerPagePlaceholder.svg'
import CustomLink from '@shared/components/customLink'
import { getImgURL } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import { getMatchPlayers } from '@shared/libs/match-detail'

const MyImage = dynamic(() => import('@shared/components/myImage'))
export default function SinglePlayerPick({ styles, data, type, playerData }) {
  const [isOpen, setIsOpen] = useState(false)
  const limit = 210
  const description =
    data?.sDescription?.length > limit ? data?.sDescription?.substring(0, isOpen ? data?.sDescription?.length : limit) + (isOpen ? '' : '...') : data?.sDescription
  const players = getMatchPlayers()
  const oPlayerFan = players[data?.oPlayerFan?.oPlayer?._id] || data?.oPlayerFan?.oPlayer
  return (
    <section className="pb-0 mb-3">
      <Col>
        <div className={`${styles.item} common-box`}>
          <div className="d-flex align-items-center">
            <div className={`${styles.imgBlock} flex-shrink-0 me-3 text-center`}>
              <MyImage
                src={getImgURL(data?.oPlayerFan?.oPlayer?.oImg?.sUrl) || playerImg}
                alt="user"
                blurDataURL={BLUR_DATA_URL_BASE64}
                placeholder="blur"
                layout="responsive"
                width="40"
                height="40"
              />
            </div>
            <div>
              <p className={`${styles.title} mb-0`}>
                <span className="font-bold mb-1 d-flex">
                  {oPlayerFan?.eTagStatus === 'a' ? (
                    <CustomLink href={`/${oPlayerFan?.oSeo?.sSlug}`}>{oPlayerFan?.sFirstName}</CustomLink>
                  ) : (
                    oPlayerFan?.sFirstName
                  )}
                </span>
                <span className={`${styles.subtitle} d-flex gap-1 text-muted xsmall-text align-items-center`}>
                  {type === 'captains' && (
                    <span>
                      <span className={`${styles.vc}`}>{data?.eType === 'v' ? 'VC' : 'C'}</span>
                    </span>
                  )}
                  <p className="d-flex gap-1 mb-0">
                    <span>{data?.oPlayerFan?.oTeam?.sAbbr && data?.oPlayerFan?.oTeam?.sAbbr}</span>
                    <span className={styles.dotSymbol}></span>
                    <span className="text-capitalize">{data?.oPlayerFan?.oPlayer?.sPlayingRole}</span>
                  </p>
                </span>
              </p>
              <div className={`${styles.point} font-bold text-center`}>{data?.oPlayerFan?.nRating}</div>
            </div>
          </div>
          {data?.sDescription && (
            <p className={`${styles.desc} ${styles.seperator} mt-2 pt-2`}>
              {description}{' '}
              {data?.sDescription?.length > limit ? (
                <span className={styles.showMore} onClick={() => setIsOpen(!isOpen)}>
                  Show {isOpen ? 'Less' : 'More'}
                </span>
              ) : null}
            </p>
          )}
        </div>
      </Col>
    </section>
  )
}

SinglePlayerPick.propTypes = {
  styles: PropTypes.any,
  data: PropTypes.object,
  type: PropTypes.string,
  playerData: PropTypes.array
}
